import { useEffect, useState } from "react";
import api from "@/lib/api";

/**
 * Phase 3.5B — Fetch the list of enabled social auth providers.
 * Returns { providers, loading }. Empty array when nothing is configured;
 * the UI hides all provider buttons in that case.
 */
export function useAuthProviders() {
  const [providers, setProviders] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let alive = true;
    api.get("/auth/providers")
      .then((r) => { if (alive) setProviders(r.data?.providers || []); })
      .catch(() => { if (alive) setProviders([]); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, []);
  return { providers, loading };
}
